import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import nlTranslations from './locales/nl.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import noTranslations from './locales/no.json';
import esTranslations from './locales/es.json';
import svTranslations from './locales/sv.json';
import srTranslations from './locales/sr.json';
import daTranslations from './locales/da.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const FALLBACK_LOCALE = 'en';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false, //to disable console logs change it to false
    returnNull: false, // Fix for typescript error:  Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz
    fallbackLng: FALLBACK_LOCALE,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: enTranslations,
      nl: nlTranslations,
      fr: frTranslations,
      de: deTranslations,
      no: noTranslations,
      es: esTranslations,
      sv: svTranslations,
      sr: srTranslations,
      da: daTranslations,
    },
  });

export default i18n;
